import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import { Provider } from 'react-redux';
import store from './store/store';
import { SnackbarProvider } from 'notistack'
import { AuthContextProvider } from "./store/auth-context";

// Chakra's modals default to 1400, under the nav wrappers (Layout, 10001), which hid their titles
// and close buttons. Keep this above $popupZIndex: an upgrade window can open over a gallery.
const chakraTheme = extendTheme({ zIndices: { modal: 10100 } });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <SnackbarProvider maxSnack={3}>
    <AuthContextProvider>
    <Provider store={store}>
    <ChakraProvider resetCSS={false} theme={chakraTheme}>
      <App />
    </ChakraProvider>
    </Provider>
    </AuthContextProvider>
    </SnackbarProvider>
);

reportWebVitals();
